import { useGetAccountByEmail } from "@/hooks/queryHooks/accountHooks";
import type { UserWRole } from "@repo/types";
import { CheckIcon, EllipsisIcon, XIcon } from "lucide-react";

export const UserSignedUp = ({ user }: { user: UserWRole }) => {
  const { data: account, loaded } = useGetAccountByEmail(user.email);
  return !loaded ? (
    <EllipsisIcon className="text-primary" />
  ) : account ? (
    <CheckIcon className="text-tertiary" />
  ) : (
    <XIcon className="text-destructive" />
  );
};
